<template>
  <nav
    id="heim-side"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link
        title="Heimdall"
        class="navbar-item logo-large"
        to="/"
      >
      <span v-if="large"><heim-icon icon="logo"></heim-icon></span>
      <span v-else><heim-icon icon="logo" :title="$t('heimdall')" v-tippy='tooltip'></heim-icon></span>
      <span class="logo-text">Heimdall</span></router-link>
    </div>
    <div class="navigation-menu">
      <div class="item">
        <router-link to="/" :class="page == 'dashboard'?'router-link-exact-active':''">
            <span v-if="large"><heim-icon icon="dashboard"></heim-icon></span>
            <span v-else><heim-icon icon="dashboard" :title="$t('dashboard')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('dashboard') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/sites" :class="page == 'sites'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="site"></heim-icon></span>
          <span v-else><heim-icon icon="site" :title="$t('sites')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('sites') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/servers" :class="page == 'servers'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="server"></heim-icon></span>
          <span v-else><heim-icon icon="server" :title="$t('servers')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('servers') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/financial" :class="page == 'financial'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="account-balance"></heim-icon></span>
          <span v-else><heim-icon icon="account-balance" :title="$t('financial')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('financial') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/projects" :class="page == 'projects'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="store"></heim-icon></span>
          <span v-else><heim-icon icon="store" :title="$t('projects')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('projects') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/maintenances" :class="page == 'maintenances'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="build"></heim-icon></span>
          <span v-else><heim-icon icon="build" :title="$t('maintenances')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('maintenances') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/users" :class="page == 'users'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="person"></heim-icon></span>
          <span v-else><heim-icon icon="person" :title="$t('users')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('users') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/monitorings" :class="page == 'monitoring'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="monitoring"></heim-icon></span>
          <span v-else><heim-icon icon="monitoring" :title="$t('monitorings')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('monitorings') }}</span>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/employees" :class="page == 'employee'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="employee"></heim-icon></span>
          <span v-else><heim-icon icon="employee" :title="$t('employees')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('employees') }}</span>
        </router-link>
      </div>
    </div>
    <div class="navbar-end">
      <div class="item lang">
        <button v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
          <span v-if="large"><flag :iso="entry.flag" v-bind:squared=false /></span>
          <span v-else><flag :iso="entry.flag" v-bind:squared=false :title="$t(entry.language)" v-tippy='tooltip' /></span>
        </button>
      </div>
      <div class="item">
        <router-link to="/setup" :class="page == 'setup'?'router-link-exact-active':''">
          <span v-if="large"><heim-icon icon="settings"></heim-icon></span>
          <span v-else><heim-icon icon="settings" :title="$t('settings')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('settings') }}</span>
        </router-link>
      </div>
      <div class="item">
        <div class="logout" @click="logout">
          <span v-if="large"><heim-icon icon="exit-to-app"></heim-icon></span>
          <span v-else><heim-icon icon="exit-to-app" :title="$t('logout')" v-tippy='tooltip'></heim-icon></span>
          <span class="label">{{ $t('logout') }}</span>
        </div>
      </div>
      <div class="item expand" :class="!large ? 'closed' : ''">
        <heim-icon-button class="toggle-nav" @click.native="toggleSideNav"><heim-icon icon="chevron-right"></heim-icon></heim-icon-button>
      </div>
    </div>
  </nav>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimIconButton from "@/components/form/button/heim-icon-button";
import { mapState } from "vuex";
import i18n from "@/plugins/i18n";
import Vue from "vue";
import VueTippy from "vue-tippy";

Vue.use(VueTippy);

export default {
  name: "heim-side",
  components: {
    HeimIcon,
    HeimIconButton
  },
  data() {
    return {
      languages: [
        { flag: "fr", language: "fr", title: "Français" },
        { flag: "gb", language: "en", title: "English" }
      ],
      tooltip: {
        placement: "right",
        theme: "heimdall",
        animateFill: false,
        animation: "shift-away"
      }
    };
  },
  computed: {
    ...mapState(["large"]),
    page() {
      if (!this.$route.matched[0]) return "";
      return this.$route.matched[0].meta.menu;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    toggleSideNav() {
      this.$store.dispatch("setupLarge");
    },
    changeLocale(locale) {
      i18n.locale = locale;
      this.$store.dispatch("setLanguage", locale);
    }
  }
};
</script>

<style>
.tippy-tooltip.heimdall-theme {
  background-color: var(--heim-secondary-color);
  color: #fff;
  font-weight: 500;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  margin-left: 10px;
}
</style>

<style scoped>
nav {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.navigation-menu {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  flex: 1;
}
.navbar-end {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}
.navbar-brand {
  display: flex;
  justify-content: center;
  font-weight: bold;
}
.navbar-tabs {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  min-height: 3.25rem;
}
.navbar-item {
  color: var(--heim-text-color);
  display: block;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}
.item {
  margin: 0.3rem;
  font-size: 1rem;
}

.item a.router-link-exact-active {
  background: var(--heim-secondary-color);
  border-radius: 3px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.item a.router-link-exact-active,
.item a.router-link-exact-active .label {
  color: var(--heim-white-color);
}

.navbar-end .lang {
  display: flex;
  flex-wrap: wrap;
}

.navbar-end .lang button {
  flex: 1;
}

.large .navbar-end .lang button:first-child {
  margin-right: 20px;
  margin-bottom: 0;
}

.navbar-end .lang button:first-child {
  margin-bottom: 10px;
}

.item a,
.item .logout {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.1rem 0.3rem;
  min-height: 2.5rem;
}

.item.active a {
  color: var(--heim-white-color);
}

.item a .label,
.item .logout .label {
  margin-left: 0.3rem;
  color: var(--heim-text-color);
}

button {
  border: 1px solid var(--heim-secondary-color);
  background: transparent;
  padding: 5px;
  border-radius: 3px;
}

.logout {
  cursor: pointer;
}

.item.expand {
  display: none;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .logo-text {
    display: none;
  }
  .large .logo-text {
    display: inline-block;
  }

  .item a,
  .item .logout {
    justify-content: center;
  }
  .large .item a,
  .large .item .logout {
    justify-content: flex-start;
  }

  .large .item .label {
    display: block;
  }

  .item .label {
    display: none;
  }

  .expand {
    text-align: center;
  }
  .expand .toggle-nav {
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
  .expand .toggle-nav .heim-icon {
    transform: rotate(-180deg);
  }
  .expand.closed .toggle-nav .heim-icon {
    transform: rotate(0);
  }

  .item.expand {
    display: block;
  }
}

@media screen and (max-width: 460px) {
  .navbar-end .lang {
    flex-direction: column;
  }
  .large .navbar-end .lang button:first-child {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>
